import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CustomTabPanel from './CustomTabPanel';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SampleGallery from './SharedComponents/SampleGallery';
import { Select, MenuItem, FormControl } from '@mui/material';

const SERVICES = ['decks', 'remodels', 'windows', 'basements'];

// Images are now loaded directly from public/sample-gallery/[service]/
const LOCAL_IMAGES = {
  decks: [
    '/sample-gallery/decks/decks001.avif',
    '/sample-gallery/decks/decks002.avif',
    '/sample-gallery/decks/decks003.avif',
    '/sample-gallery/decks/decks004.avif',
  ],
  remodels: [
    '/sample-gallery/remodels/remodels001.avif',
    '/sample-gallery/remodels/remodels002.avif',
    '/sample-gallery/remodels/remodels003.avif',
    '/sample-gallery/remodels/remodels004.avif',
  ],
  windows: [
    '/sample-gallery/windows/windows001.avif',
    '/sample-gallery/windows/windows002.avif',
    '/sample-gallery/windows/windows003.avif',
    '/sample-gallery/windows/windows004.avif',
  ],
  basements: [
    '/sample-gallery/basements/basements001.avif',
    '/sample-gallery/basements/basements002.avif',
    '/sample-gallery/basements/basements003.avif',
    '/sample-gallery/basements/basements004.avif',
  ],
};

const StyledTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "black",
  },
});

const StyledTab = styled(Tab)({
  "& .MuiTouchRipple-root": {
    color: "black",
  },
  fontWeight: "normal",
  "&.Mui-selected": {
    fontWeight: "bold",
    color: "black",
  },
  fontSize: "24px"
});

export default function CustomTabs() {
  const [value, setValue] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSelectChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {isMobile ? (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={value}
            onChange={handleSelectChange}
            displayEmpty
            sx={{
              width: '80vw',
              display: 'block',
              margin: '0 auto',
              color: 'black',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'black',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'black',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'black',
              },
              '& .MuiSvgIcon-root': {
                color: 'black',
              },
            }}
          >
            <MenuItem value={0}>Decks</MenuItem>
            <MenuItem value={1}>Remodels</MenuItem>
            <MenuItem value={2}>Windows</MenuItem>
            <MenuItem value={3}>Basements</MenuItem>
          </Select>
        </FormControl>
      ) : (
        <StyledTabs
          value={value}
          onChange={handleChange}
          centered={true}
        >
          <StyledTab value={0} label="Decks" />
          <StyledTab value={1} label="Remodels" />
          <StyledTab value={2} label="Windows" />
          <StyledTab value={3} label="Basements" />
        </StyledTabs>
      )}
      <CustomTabPanel key={SERVICES[0]} value={value} index={0} description={`Spend your summer relaxing on a beautiful custom deck!`}>
        <SampleGallery
          images={LOCAL_IMAGES[SERVICES[0]] || []}
          service={SERVICES[0]}
        />
      </CustomTabPanel>
      <CustomTabPanel key={SERVICES[1]} value={value} index={1} description={`Reimagine your home, just the way you want it!`}>
        <SampleGallery
          images={LOCAL_IMAGES[SERVICES[1]] || []}
          service={SERVICES[1]}
        />
      </CustomTabPanel>
      <CustomTabPanel key={SERVICES[2]} value={value} index={2} description={`Brighten your days with new energy-efficient windows!`}>
        <SampleGallery
          images={LOCAL_IMAGES[SERVICES[2]] || []}
          service={SERVICES[2]}
        />
      </CustomTabPanel>
      <CustomTabPanel key={SERVICES[3]} value={value} index={3} description={`Expand your living space - from unfinished to unforgettable!`}>
        <SampleGallery
          images={LOCAL_IMAGES[SERVICES[3]] || []}
          service={SERVICES[3]}
        />
      </CustomTabPanel>
    </Box>
  );
}